/**
 * Absolute URL for an image the API reports.
 *
 * Anything uploaded through the admin panel comes back as a full S3 URL and
 * passes through untouched. Files the backend serves itself — the instalment
 * card art shipped under media/, for one — arrive as a path, and that path is
 * relative to the API host rather than to the storefront, so it has to be
 * joined onto the API origin.
 */
export const resolveMediaUrl = (url?: string | null): string => {
  if (!url) return "";
  if (/^(https?:)?\/\//i.test(url) || url.startsWith("data:")) return url;

  const base = process.env.REACT_APP_API_BASE_URL;
  if (!base) return url;

  try {
    // In development the base is a relative path served through the dev proxy,
    // so it needs an origin of its own before it can act as one.
    const apiOrigin = new URL(base, window.location.origin);
    return new URL(url, apiOrigin).href;
  } catch {
    return url;
  }
};
